import { memo, useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { Route, Routes } from 'react-router-dom'

import ProtectedRoute from '../components/Auth/ProtectedRoute'
import { isAdmin } from '../utils/isAdmin'
import { AdminPage } from './AdminPage'
import { CarouselEditPage } from './CarouselEditPage'
import {
  AdminHeader,
  allowedAdminEmailForPrompt,
} from './components/AdminHeader'
import { WithGenerateMentor } from './HOCs/WithGenerateMentor'
import { PromptPage } from './PromptPage'
import { ResentPage } from './ResentPage'

const AdminRouter: React.FC = memo(() => {
  const { user } = useAuth()
  useEffect(() => {
    if (user && !isAdmin(user)) {
      window.location.href = '/'
    }
  }, [user])

  // TODO: remove this check when we have a proper role
  const isAllowedAdminEmail = allowedAdminEmailForPrompt?.includes(
    user?.profile.email || '',
  )

  return (
    <WithGenerateMentor>
      <AdminHeader />
      <Routes>
        <Route
          path="/all-mentors"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recent"
          element={
            <ProtectedRoute>
              <ResentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/carousel"
          element={
            <ProtectedRoute>
              <CarouselEditPage />
            </ProtectedRoute>
          }
        />
        {isAllowedAdminEmail && (
          <Route
            path="/prompts"
            element={
              <ProtectedRoute>
                <PromptPage />
              </ProtectedRoute>
            }
          />
        )}
      </Routes>
    </WithGenerateMentor>
  )
})

export { AdminRouter }
